<script lang="ts">
    import type { TMarket } from '$lib/services/market/types';
    import ProductItem from './ProductItem.svelte';
    import LoginItem from './LoginItem.svelte';
    import RegistrationItem from './RegistrationItem.svelte';
    import type { TNavItem } from './types';
    import { setContext } from 'svelte';
    import { BAR_CONTEXT } from './constants';

    export let market: TMarket;
    export let isLoggedIn: boolean;
    export let items: Record<string, TNavItem>;

    setContext(BAR_CONTEXT, 'bottom-bar');

    $: ({ productItem, wallet, profile, moreMenuItem, loginItem, registrationItem } = items);
</script>

<nav
    class="fixed bottom-0 z-[20] flex h-[var(--bottom-bar-height,64px)] w-full justify-between gap-2xs bg-purple-90 phablet:px-sm tablet:hidden tablet:h-0"
>
    {#if isLoggedIn}
        <ProductItem item={productItem} />
        <ProductItem item={wallet} />
        <ProductItem item={profile} />
        <ProductItem item={moreMenuItem} />
    {:else}
        <div class="flex gap-2xs">
            {#if market.slug !== 'sv'}
                <div class="flex items-center justify-center text-center">
                    <LoginItem item={loginItem} />
                </div>
            {/if}

            <div class="flex items-center justify-center pb-3xs">
                <RegistrationItem item={registrationItem} {market} />
            </div>
        </div>

        <div class="flex gap-2xs">
            <ProductItem item={productItem} />
            <ProductItem item={moreMenuItem} />
        </div>
    {/if}
</nav>
